module.exports = __webpack_public_path__ + "assets/img/17_1044_big.ebcdd072.jpg";